import { useParams, useNavigate } from "react-router-dom";
import CategoriesBar from "../../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../../globalcomponents/navbar/NavbarTwo";
import { useAppDispatch } from "../../../../Redux/hooks";
import { RootState } from "../../../../store";
import { useAppSelector } from "../../../../Redux/hooks";
import { fetchProductById } from "../../../../Redux/ecommersProduct/slice";
import { createReviewWithMedia } from "../../../../Redux/products review/slice";
import { useEffect, useState } from "react";
import { reviewType } from "../../../../Redux/products review/types";
import { uploadToCloudinary } from "../../../../utility/uploadToCloudinary";

interface FilePreview {
  file: File;
  preview: string;
}

const SubmitReview = () => {
  const id = useParams().id;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  

  const [rating, setRating] = useState<number>(0);
  const [hoveredRating, setHoveredRating] = useState<number>(0);
  const [description, setDescription] = useState<string>("");
  const [imagePreviews, setImagePreviews] = useState<FilePreview[]>([]);
  const [videoPreviews, setVideoPreviews] = useState<FilePreview[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const { currentProduct, loading, error } = useAppSelector(
    (state: RootState) => state.eCommerceProducts
  );

  const { isCreating } = useAppSelector(
    (state: RootState) => state.productsReview
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchProductById(id as string));
    }
  }, [dispatch, id]);

  const handleRatingClick = (value: number) => {
    setRating(value);
  };

  const handleImageSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const newPreviews = files.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));
      setImagePreviews((prev) => [...prev, ...newPreviews]);
    }
  };

  const handleVideoSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const newPreviews = files.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));
      setVideoPreviews((prev) => [...prev, ...newPreviews]);
    }
  };

  const removeImage = (index: number) => {
    setImagePreviews((prev) => {
      URL.revokeObjectURL(prev[index].preview);
      return prev.filter((_, i) => i !== index);
    });
  };

  const removeVideo = (index: number) => {
    setVideoPreviews((prev) => {
      URL.revokeObjectURL(prev[index].preview);
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (rating === 0) {
      alert("Please select a rating");
      return;
    }

    if (!id) {
      alert("Product ID is missing");
      return;
    }

    setIsSubmitting(true);
    
    try {
      // 1. Upload images to Cloudinary
      const imageUrls = await Promise.all(
        imagePreviews.map((preview) => uploadToCloudinary(preview.file))
      );

      // 2. Upload videos to Cloudinary
      const videoUrls = await Promise.all(
        videoPreviews.map((preview) => uploadToCloudinary(preview.file))
      );

      // 3. Prepare review data with URLs
      const reviewData = {
        rating,
        description,
        productId: id,
        images: imageUrls,
        videos: videoUrls,
        reviewType: reviewType.PRODUCT,
      };

      await dispatch(createReviewWithMedia(reviewData)).unwrap();
      alert("Review submitted successfully!");
      
      // Cleanup object URLs
      imagePreviews.forEach((preview) => URL.revokeObjectURL(preview.preview));
      videoPreviews.forEach((preview) => URL.revokeObjectURL(preview.preview));
      
      // Navigate back or to reviews page
      navigate(-1);
    } catch (err: any) {
      alert(`Failed to submit review: ${err.message || "Please try again."}`);
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      imagePreviews.forEach((preview) => URL.revokeObjectURL(preview.preview));
      videoPreviews.forEach((preview) => URL.revokeObjectURL(preview.preview));
    };
  }, []);




  return (
    <>
      <div className="display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className="container mx-auto w-70 mt-3 mb-5">
          <div className="d-flex justify-content-between align-items-center lh-1 mb-4">
            <div>
              <h2 className="text-dark fw-bold">Submit Review</h2>
              <p className="text-muted mb-0">Share your experience with this product</p>
            </div>
          </div>

          <div className="border p-4 mt-3 mb-3 rounded shadow-sm bg-white">
            {/* Product Section */}
            <div className="mb-4 pb-4 border-bottom">
              <div className="d-flex align-items-start gap-4">
                <div className="text-center">
                  <div className="border rounded p-2 bg-light">
                    <img
                      className="seller-feedback-images"
                      style={{ width: "120px", height: "120px", objectFit: "cover" }}
                      src={currentProduct?.variations?.[0]?.media?.images?.[0]}
                      alt={currentProduct?.name || "Product image"}
                    />
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h5 className="text-dark fw-semibold mb-2">
                    {currentProduct?.name}
                  </h5>
                  <p className="text-muted small mb-0">
                    {currentProduct?.description || "Share your thoughts about this product"}
                  </p>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              {/* Rating Section */}
              <div className="mb-4">
                <label className="fw-semibold fs-5 text-dark mb-3">
                  Overall Rating <span className="text-danger">*</span>
                </label>
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex gap-2">
                    {Array.from({ length: 5 }).map((_, index) => {
                      const starValue = index + 1;
                      return (
                        <span
                          key={index}
                          onClick={() => handleRatingClick(starValue)}
                          onMouseEnter={() => setHoveredRating(starValue)}
                          onMouseLeave={() => setHoveredRating(0)}
                          style={{ cursor: "pointer", fontSize: "2.8rem" }}
                        >
                          <i
                            className={`bi  ${
                              starValue <= (hoveredRating || rating)
                                ? "bi-star-fill text-warning"
                                : "bi-star text-warning"
                            }`}
                          ></i>
                        </span>
                      );
                    })}
                  </div>
                  {rating > 0 && (
                    <span className="text-muted fs-5">
                      {rating} out of 5 stars
                    </span>
                  )}
                </div>
              </div>

              {/* Review Text */}
              <div className="mb-4">
                <label className="fw-bold fs-5 text-dark mb-2">
                  Write Your Review
                </label>
                <div className="input-group">
                  <textarea
                    className="form-control fs-5 p-3 border-1 rounded-4 border-black"
                    rows={7}
                    placeholder="What did you like or dislike? What did you use this product for?"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ resize: "vertical" }}
                  ></textarea>
                </div>
                <small className="text-muted">
                  {description.length} characters (optional)
                </small>
              </div>

              {/* Image Upload */}
              <div className="mb-4">
                <label className="fw-bold fs-5 text-dark mb-2">
                  Add Photos
                </label>
                <p className="text-muted fs-6 mb-2">
                  Shoppers find images more helpful than text alone.
                </p>
                
                {imagePreviews.length > 0 && (
                  <div className="d-flex flex-wrap gap-3 mb-3">
                    {imagePreviews.map((preview, index) => (
                      <div
                        key={index}
                        className="position-relative border rounded p-2 bg-light"
                        style={{ width: "120px", height: "120px" }}
                      >
                        <img
                          src={preview.preview}
                          alt={`Preview ${index + 1}`}
                          className="w-100 h-100 rounded"
                          style={{ objectFit: "cover" }}
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle p-0"
                          style={{ width: "25px", height: "25px" }}
                          onClick={() => removeImage(index)}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <div className="input-group">
                  <input
                    type="file"
                    className="form-control fs-5 border-1 rounded-4 border-black"
                    accept="image/*"
                    multiple
                    onChange={handleImageSelect}
                    id="imageInput"
                  />
                  <label
                    className="input-group-text btn btn-outline-secondary fs-5"
                    htmlFor="imageInput"
                  >
                    <i className="bi bi-image me-2"></i>
                    Choose Images
                  </label>
                </div>
              </div>

              {/* Video Upload */}
              <div className="mb-4">
                <label className="fw-bold fs-5 text-dark mb-2">
                  Add Videos
                </label>
                <p className="text-muted fs-6 mb-2">
                  Show how the product works or looks in action.
                </p>

                {videoPreviews.length > 0 && (
                  <div className="d-flex flex-wrap gap-3 mb-3">
                    {videoPreviews.map((preview, index) => (
                      <div
                        key={index}
                        className="position-relative border rounded p-2 bg-light"
                        style={{ width: "200px" }}
                      >
                        <video
                          src={preview.preview}
                          className="w-100 rounded"
                          style={{ height: "150px", objectFit: "cover" }}
                          controls
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle p-0"
                          style={{ width: "25px", height: "25px" }}
                          onClick={() => removeVideo(index)}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                        <small className="text-muted d-block mt-1">
                          {preview.file.name}
                        </small>
                      </div>
                    ))}
                  </div>
                )}

                <div className="input-group">
                  <input
                    type="file"
                    className="form-control fs-5 border-1 rounded-4 border-black"
                    accept="video/*"
                    multiple
                    onChange={handleVideoSelect}
                    id="videoInput"
                  />
                  <label
                    className="input-group-text btn btn-outline-secondary fs-5"
                    htmlFor="videoInput"
                  >
                    <i className="bi bi-camera-video me-2"></i>
                    Choose Videos
                  </label>
                </div>
              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-center align-items-center gap-3 mt-4 pt-3 border-top">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-lg px-5"
                  onClick={() => navigate(-1)}
                  disabled={isSubmitting || isCreating}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-yellow btn-lg px-5"
                  disabled={isSubmitting || isCreating || rating === 0}
                >
                  {isSubmitting || isCreating ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Submitting...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-send me-2"></i>
                      Submit Review
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="display-mini display-mob">
       
        <div className="container mx-auto w-100 mt-3 mb-5">
          <div className="d-flex justify-content-between align-items-center lh-1 mb-2">
            <div>
              <h2 className="text-dark fw-bold">Submit Review</h2>
              <p className="text-muted mb-0">Share your experience with this product</p>
            </div>
          </div>

          <div className="border p-4 mt-3 mb-3 rounded shadow-sm bg-white">
            {/* Product Section */}
            <div className="mb-4 pb-4 border-bottom">
              <div className="d-flex align-items-start gap-4">
                <div className="text-center">
                  <div className="border rounded p-2 bg-light">
                    <img
                      className="seller-feedback-images"
                      style={{ width: "120px", height: "120px", objectFit: "cover" }}
                      src={currentProduct?.variations?.[0]?.media?.images?.[0]}
                      alt={currentProduct?.name || "Product image"}
                    />
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h5 className="text-dark fw-semibold mb-2">
                    {currentProduct?.name}
                  </h5>
                  <p className="text-muted small mb-0">
                    {currentProduct?.description || "Share your thoughts about this product"}
                  </p>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              {/* Rating Section */}
              <div className="mb-4">
                <label className="fw-semibold fs-5 text-dark mb-3">
                  Overall Rating <span className="text-danger">*</span>
                </label>
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex gap-2">
                    {Array.from({ length: 5 }).map((_, index) => {
                      const starValue = index + 1;
                      return (
                        <span
                          key={index}
                          onClick={() => handleRatingClick(starValue)}
                          onMouseEnter={() => setHoveredRating(starValue)}
                          onMouseLeave={() => setHoveredRating(0)}
                          style={{ cursor: "pointer", fontSize: "2.8rem" }}
                        >
                          <i
                            className={`bi  ${
                              starValue <= (hoveredRating || rating)
                                ? "bi-star-fill text-warning"
                                : "bi-star text-warning"
                            }`}
                          ></i>
                        </span>
                      );
                    })}
                  </div>
                  {rating > 0 && (
                    <span className="text-muted fs-5">
                      {rating} out of 5 stars
                    </span>
                  )}
                </div>
              </div>

              {/* Review Text */}
              <div className="mb-4">
                <label className="fw-bold fs-5 text-dark mb-2">
                  Write Your Review
                </label>
                <div className="input-group">
                  <textarea
                    className="form-control fs-5 p-3 border-1 rounded-4 border-black"
                    rows={7}
                    placeholder="What did you like or dislike? What did you use this product for?"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ resize: "vertical" }}
                  ></textarea>
                </div>
                <small className="text-muted">
                  {description.length} characters (optional)
                </small>
              </div>

              {/* Image Upload */}
              <div className="mb-4">
                <label className="fw-bold fs-5 text-dark mb-2">
                  Add Photos
                </label>
            
                
                {imagePreviews.length > 0 && (
                  <div className="d-flex flex-wrap gap-3 mb-3">
                    {imagePreviews.map((preview, index) => (
                      <div
                        key={index}
                        className="position-relative border rounded p-2 bg-light"
                        style={{ width: "120px", height: "120px" }}
                      >
                        <img
                          src={preview.preview}
                          alt={`Preview ${index + 1}`}
                          className="w-100 h-100 rounded"
                          style={{ objectFit: "cover" }}
                        />
                        <button
                          type="button"
                          className="btn fs-4 btn-large position-absolute top-0 end-0 m-1 rounded-circle p-0"
                          style={{ width: "25px", height: "25px" }}
                          onClick={() => removeImage(index)}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <div className="input-group">
                  <input
                    type="file"
                    className="form-control fs-6 border-1 rounded-4 border-black"
                    accept="image/*"
                    multiple
                    onChange={handleImageSelect}
                    id="imageInput"
                  />
                
                </div>
              </div>

              {/* Video Upload */}
              <div className="mb-4">
                <label className="fw-bold fs-5 text-dark mb-2">
                  Add Videos
                </label>
            

                {videoPreviews.length > 0 && (
                  <div className="d-flex flex-wrap gap-3 mb-3">
                    {videoPreviews.map((preview, index) => (
                      <div
                        key={index}
                        className="position-relative border rounded p-2 bg-light"
                        style={{ width: "200px" }}
                      >
                        <video
                          src={preview.preview}
                          className="w-100 rounded"
                          style={{ height: "150px", objectFit: "cover" }}
                          controls
                        />
                        <button
                          type="button"
                          className="btn fs-4 btn-large position-absolute top-0 end-0 m-1 rounded-circle p-0"
                          style={{ width: "25px", height: "25px" }}
                          onClick={() => removeVideo(index)}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                        <small className="text-muted d-block mt-1">
                          {preview.file.name}
                        </small>
                      </div>
                    ))}
                  </div>
                )}

                <div className="input-group">
                  <input
                    type="file"
                    className="form-control fs-6 border-1 rounded-4 border-black"
                    accept="video/*"
                    multiple
                    onChange={handleVideoSelect}
                    id="videoInput"
                  />
                 
                </div>
              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-center mb-5 align-items-center gap-2 mt-4 pt-3 border-top">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-lg px-4"
                  onClick={() => navigate(-1)}
                  disabled={isSubmitting || isCreating}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-yellow btn-lg px-3"
                  disabled={isSubmitting || isCreating || rating === 0}
                >
                  {isSubmitting || isCreating ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Submitting...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-send me-2 text-dark"></i>
                      Submit Review
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubmitReview;
